/**************************************************
 * Nombre:       Contactos_Contactanos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {CONTACTOS, NEGRITA} from "../../../Constantes";
import Tarjeta_Contacto from "../../Tarjetas/Tarjeta_Contacto";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Contacto from "../../Formularios/Formulario_Contacto";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Contactos_Contactanos = () => {
    const {sCell} = useResponsive()
    const {props} = useFormulario({valoresDefecto: {}})

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}
                      spacing={10}
                >
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 6}}
                        spacing={0}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 18, color: theme.palette.primary.main, fontWeight: 600}}>
                                Contactanos
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Typography sx={{fontSize: 40, fontFamily: NEGRITA, lineHeight: 1.1, fontWeight: 600}}>
                                Contáctanos y construye un futuro inteligente.
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Typography sx={{fontSize: 16}}>
                                Encuentra todos nuestros medios de atención aquí y conecta con nosotros con un solo
                                clic.
                            </Typography>
                        </Grid>


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{
                                borderTop: 2,
                                borderBottom: 2,
                                pt: 4,
                                pb: 2,
                                mt: 4
                            }}
                            spacing={sCell ? 1 : 3}
                        >


                            {CONTACTOS.map((it) => {
                                return (
                                    <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                        <Tarjeta_Contacto item={it}/>
                                    </Grid>
                                )
                            })}

                        </Grid>


                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 6}}>


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Formulario_Contacto props={props}/>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Contactos_Contactanos